import { memo } from 'react'

import { usePrimeMode } from '@hooks/usePrimeMode'
import { PUBLIC_NODE_ENV } from '@lib/constants'

export const DevMarker = memo(() => {
  const isDev = PUBLIC_NODE_ENV === 'development'
  const isQA = PUBLIC_NODE_ENV === 'qa'
  const isPrimeMode = usePrimeMode()

  if (!isDev && !isQA) return null
  if (isPrimeMode) return null

  return (
    <div
      className={`fixed z-[39] top-0 left-0 h-20 w-full ${isDev ? 'bg-green-100 dark:bg-green-900/50' : 'bg-blue-200 dark:bg-blue-900/50'}`}
    />
  )
})
